import React from 'react';

import { Checkbox, Label, LabeledControl } from '@zillow/constellation';

type Props = {
  onBoxClick: (event) => void;
  setSectionValues: (keyValuePairs: object) => void;
  FIELD_NAME: string;
  LABEL: string;
  checked: boolean;
  controlId: string;
};

export default function RulesCheckbox({ onBoxClick, FIELD_NAME, LABEL, checked, controlId }: Props): JSX.Element {
  return (
    <LabeledControl
      controlId={controlId}
      label={<Label>{LABEL}</Label>}
      control={<Checkbox data-test="checkbox" onClick={onBoxClick} data-value={FIELD_NAME} checked={checked} />}
    />
  );
}
